export const useHeightStyles = () => {
  const topBarStyles = "lg:h-[calc(100vh-64px)]";
  const topBarStylesWithMasquerade = "lg:h-[calc(100vh-48px-64px)]";

  return {
    topBarStyles,
    topBarStylesWithMasquerade,
  };
};
